import { createSelector } from 'reselect';
import memoize from 'lodash.memoize';

function arraysEqual(a, b) {
  if (a === b) return true;
  if (a === null || b === null) return false;
  if (a.length !== b.length) return false;

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

export const isSameProduct = (a, b) => {
  if (a === b) return true;
  if (typeof a === 'object' && typeof b === 'object' && a && b) {
    if (a.id === b.id) {
      if (!a.components && !b.components) {
        return true;
      }
      if (arraysEqual((a.components || []).sort(), (b.components || []).sort())) {
        return true;
      }
    }
  }
  return false;
};

/**
 * Returns a list of opted in products id from the state
 * @param {object} state
 */
export const optedinSelector = state => state.optedin || [];

/**
 * Creates a function with state arguments that return the true when
 * productId is in the optedin array
 * @param {String} productId
 */
export const makeOptedinSelector = memoize(productId =>
  // createSelector will return a memoized selector that will return same
  // value for same argument. in other words if the portion of the state
  // that optedinSelector has change this code recomputes the optedin.find(),
  // else, returns the cached
  createSelector(
    optedinSelector,
    optedin => optedin.find(b => isSameProduct(productId, b))
  )
);

export const frequencySelector = state => state.frequency;

export const makeProductFrequencySelector = memoize(productId =>
  createSelector(
    makeOptedinSelector(productId),
    productOptin => (productOptin && productOptin.frequency) || null
  )
);
/**
 * Convert a string from camel case to kebab case.
 * @param {String} string
 * @returns {String}
 */
export const kebabCase = string => {
  return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};

/**
 * Resolve element configuration by looking into html attribute or state config
 *
 * @param {Object} state
 * @param {HTMLElement} element
 * @param {String} key
 * @returns {Object}
 */
export const configSelector = (state, element, key, defaultValue) => ({
  [key]:
    (element && element.getAttribute && element.getAttribute(kebabCase(key))) ||
    (state.config && state.config[key]) ||
    defaultValue
});

export const templateSelector = (state, ownProps) => ({
  ...(ownProps &&
    ownProps.tagName &&
    state.templatesByTagName && { template: state.templatesByTagName[ownProps.tagName] })
});
